function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 2.5c0-.175.03-.344.085-.5H3.5A1.5 1.5 0 002 3.5v10A1.5 1.5 0 003.5 15H7v2H5.5a.5.5 0 000 1h9a.5.5 0 000-1H13v-2h3.5a1.5 1.5 0 001.5-1.5V7h-2.5c-.432 0-.82-.182-1.094-.474l-.255.765A2.5 2.5 0 0112 8.99V9.5a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 016 9.5v-3A1.5 1.5 0 017.5 5h3c.432 0 .82.182 1.094.474l.255-.765A2.5 2.5 0 0114 3.01V2.5zM12 15v2H8v-2h4zm3.5-13a.5.5 0 00-.5.5V4h-.78a1.5 1.5 0 00-1.422 1.026l-.544 1.632a.5.5 0 01-.475.342H11v-.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V8h.78a1.5 1.5 0 001.422-1.026l.544-1.632A.5.5 0 0114.221 5H15v.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3z",
  fill: "#6264A7"
});

function SvgLifecyclePowerautomateFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecyclePowerautomateFilledIcon;